import { Tagß, type TagßProps } from '@otter-ai/den-components';
import { useTranslations } from 'next-intl';

export type NewTagProps = Pick<TagßProps, 'size'>;

export function NewTag({ size = 'md' }: NewTagProps) {
  const t = useTranslations('settings:integrations.tags');
  return (
    <Tagß data-testid="new-tag" size={size} color="purple">
      {t('new')}
    </Tagß>
  );
}
